import { render } from "./StepButton.vue?vue&type=template&id=f112d2e2"
import script from "./StepButton.vue?vue&type=script&lang=js"
export * from "./StepButton.vue?vue&type=script&lang=js"

import "./StepButton.vue?vue&type=style&index=0&id=f112d2e2&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__